import React from 'react';
import { useIntl } from 'react-intl';

import {
  WizardScreen,
  FooterMode
} from '@futrli/ui-components/components/sidebar/wizard/screens/wizard-screen/wizard-screen';
import { WizardFinished } from '@futrli/ui-components/components/sidebar/wizard/wizard-finished/wizard-finished';

export interface WorkspaceNameUpdatedWizardScreenProps {
  onClose: () => void;
}

export const WorkspaceNameUpdatedWizardScreen = ({ onClose }: WorkspaceNameUpdatedWizardScreenProps) => {
  const intl = useIntl();

  return (
    <WizardScreen footerMode={FooterMode.CREATED} onCancel={onClose}>
      <WizardFinished
        text={intl.formatMessage({
          id: 'workspaces.changes_saved',
          defaultMessage: 'Changes saved'
        })}
      />
    </WizardScreen>
  );
};
